import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/v2/form";
import { Input } from "@/components/ui/v2/input";
import { AddClientRequest } from "@/types/request/AddClientRequest";

const ClientDetailsStep = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<AddClientRequest>();

  return (
    <>
      <FormField
        control={control}
        name="name"
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              {t("admin.client.addClient.clientInfo.companyName")}
            </FormLabel>
            <FormControl>
              <Input
                {...field}
                placeholder={t("admin.client.addClient.clientInfo.companyName")}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <div className="grid gap-4 grid-cols-1 lg:grid-cols-3 items-start">
        <FormField
          control={control}
          name="firstName"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                {t("admin.client.addClient.clientInfo.firstName")}
              </FormLabel>
              <FormControl>
                <Input
                  {...field}
                  placeholder={t("admin.client.addClient.clientInfo.firstName")}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={control}
          name="infix"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                {t("admin.client.addClient.clientInfo.infix")}
                <span className="text-muted-foreground font-normal">
                  {t("common.optional")}
                </span>
              </FormLabel>
              <FormControl>
                <Input
                  {...field}
                  value={field.value ?? ""}
                  placeholder={t("admin.client.addClient.clientInfo.infix")}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={control}
          name="lastName"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                {t("admin.client.addClient.clientInfo.lastName")}
              </FormLabel>
              <FormControl>
                <Input
                  {...field}
                  placeholder={t("admin.client.addClient.clientInfo.lastName")}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <div className="grid gap-4 grid-cols-1 lg:grid-cols-2 items-start">
        <FormField
          control={control}
          name="emailAddress"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                {t("admin.client.addClient.clientInfo.emailAddress")}
              </FormLabel>
              <FormControl>
                <Input
                  {...field}
                  placeholder={t(
                    "admin.client.addClient.clientInfo.emailAddress"
                  )}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={control}
          name="phoneNumber"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                {t("admin.client.addClient.clientInfo.phoneNumber")}
                <span className="text-muted-foreground font-normal">
                  {t("common.optional")}
                </span>
              </FormLabel>
              <FormControl>
                <Input {...field} placeholder="088 123 45 67" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <FormField
        control={control}
        name="jobTitle"
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              {t("admin.client.addClient.clientInfo.jobTitle")}
              <span className="text-muted-foreground font-normal">
                {t("common.optional")}
              </span>
            </FormLabel>
            <FormControl>
              <Input
                {...field}
                value={field.value ?? ""}
                placeholder={t("admin.client.addClient.clientInfo.jobTitle")}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};

export default ClientDetailsStep;
